export default __webpack_public_path__ + "static/media/boat_illustration.b5d3000e.svg";